import React from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

const StyledTabs = withStyles({
  root: {
    root: {
      width: "100%",
      "& PrivateTabIndicator-root-31": {
        display: "none",
      },
    },
    indicator: {
      display: "none",
    },

    centered: {
      alignItems: "center",
      justifyContent: "center",
    },
  },
})(Tabs);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    width: "278px !important",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: 14,
    // backgroundColor: "#3B86FF1A",
    height: "37px !important",
    marginBottom: 22,
    borderRadius: 5,
    color: "#1e1e1e",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#ddd",
    backgroundColor: "rgba(7,127,131,.75)",

    // "&:hover": {
    //   color: "#40a9ff",
    //   opacity: 1,
    // },
    "&:hover,&.Mui-selected": {

      color: "#fff",
      backgroundColor: "rgba(7,127,131,1)",
      opacity: 1
    }

    // "&:focus": {
    //   color: "#40a9ff",
    // },
  },
  selected: {},
  // textColorInherit: { color: "#3B86FF" },
}))((props) => <Tab disableRipple {...props} />);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ width: "65%" }}
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          width="100%"
          ml="30px"
          boxShadow="0px 3px 5px #0000001A"
          borderRadius="5px"
          padding="0 40px 35px  40px"
          paddingTop={"25px"}
          flexGrow={1}
        >
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    "& .PrivateTabIndicator-root-31 ": {
      display: "none",
    },
    "& .MuiTabs-root": {
      border: "none",
      minHeight: "58vh",
      boxShadow: "0px 3px 5px #0000001A",
      borderRadius: "5px",
      padding: "0 25px 25px 25px",
      paddingTop: '25px',
      marginLeft: "30px"
    },
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));

/**
 * @props
 ** tabNames --- An Array of strings,
 ** tabContent --- it must be an array of react components with hardcoded key.
 *
 * @description the tab names array and components array order matters
 * The component on the 0 index in the components array is for the tab that is on the 0
 *  index in the tabNames array too.
 *
 * @example tabNames = ['first name', 'second name']
    componets = [<ThisCmpIsForFirstName key={0} />, <ThisCmpIsForSecondName key={1} />]
 */
export default function CustomeVerticalTabs(props) {
  const { tabNames, tabContent } = props;

  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <StyledTabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        indicatorColor="primary"
        onChange={handleChange}
        aria-label="Vertical tabs"
        className={classes.tabs}
      >
        {tabNames?.map((name, i) => (
          <StyledTab key={i} label={name} {...a11yProps(i)} />
        ))}
      </StyledTabs>
      {tabContent?.map((item, i) => (
        <TabPanel key={i} value={value} index={i}>
          {item}
        </TabPanel>
      ))}
    </div>
  );
}
